import { render, staticRenderFns } from "./Streaming.vue?vue&type=template&id=0aad0e3b&scoped=true&"
import script from "./Streaming.vue?vue&type=script&lang=js&"
export * from "./Streaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad0e3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aad0e3b')) {
      api.createRecord('0aad0e3b', component.options)
    } else {
      api.reload('0aad0e3b', component.options)
    }
    module.hot.accept("./Streaming.vue?vue&type=template&id=0aad0e3b&scoped=true&", function () {
      api.rerender('0aad0e3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/SettingRenew/Contents/Streaming.vue"
export default component.exports